import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { removeFavoriteMutate } from 'queries';
import { reducer } from 'actions/registry/fetch-installed-apps';

export default new AsyncActionHandler({
  name: 'remove_favorite',
  stateProp: 'removeFavorite',
  handler: (id) => async () => {
    const { data } = await apollo.mutate({
      mutation: removeFavoriteMutate,
      variables: {
        id
      }
    });

    return {
      favorites: data.favorites
    };
  },
  reduce: reducer
});
